<template>
  <div>
    <div>
      <b-tabs pills card>
        <b-tab :title="$t('Main')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="selectAccountingPeriod.length > 0" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit && !accountingPeriodId"/>
                <b-form-invalid-feedback id="inputFeedback">
                  {{ $t('Select accounting period') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-select :options="listOfChargePolicy" v-model="telephonyService.policy_id"/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormChargePolicies">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :disabled="isEdit && telephonyService.scheme_id>0" :options="listOfCoefficientScheme" v-model="telephonyService.scheme_id"  @change="coeffSchemeChanged"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input  :disabled="telephonyService.scheme_id>0" type="number" v-model="telephonyService.cost_coef"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
              <b-input-group>
                <b-form-input type="text" v-model="telephonyService.charged_in_curr_period" disabled/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormCharged">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('Additional')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <flat-picker :key="rerenderStartDate"
              :isDisabled="isEdit"
              @onDateChanged="(unixDate) => {telephonyService.start_date = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(telephonyService.start_date ? telephonyService.start_date : new Date()/1000 ).toDate())}"
              />
            </b-form-group>
            <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <flat-picker :key="rerenderExpireDate"
              :isDisabled="infinityDate"
              @onDateChanged="(unixDate) => {telephonyService.expire_date = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(telephonyService.expire_date ? telephonyService.expire_date : new Date()/1000 ).toDate())}"
              />
              <b-form-checkbox v-model="infinityDate">{{ $t('Infinity date') }}</b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="userHouse" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
                <b-input-group-append>
                <b-button variant="secondary" size="sm" @click="clearHouse">{{ $t('Clear') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Address comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="telephonyService.house_comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="telephonyService.comment"/>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('Telephony numbers')" :active="tabTelNum">
          <b-row>
            <b-col>
              <md-button @click.stop="showAddTelNum" class="md-raised md-dense">{{ $t('Add') }}</md-button>
            </b-col>
          </b-row>
          <b-table
          small
          striped
          hover
          :items="tableTelNum"
          :fields="fieldsNum"
          @row-clicked="rowClickHandler"
          @row-dblclicked="onRowDoubleClick">
            <template v-slot:cell(actions)="row">
              <i @click.stop="ClickOnEditTelNumButton(row)" class="primary fa fa-edit fa-lg" />
              <i @click.stop="deleteTelNum(row)" class="danger fa fa-trash-alt fa-lg" />
            </template>
          </b-table>
        </b-tab>
          <b-tab :title="$t('Radius parameters')">
        <b-row>
          <b-col>
              <md-button class="md-raised md-dense" @click="swohAddRadiusAttr">{{ $t('Add') }}</md-button>
            </b-col>
          </b-row>
          <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
            <template v-slot:cell(actions)="row">
              <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg"/>
              <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg"/>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </div>

    <modal-ok-cancel @save="saveTelephonyService" @cancel="hideSelectService" size="lg"/>

    <b-modal hide-footer ref="modalTelNum" :title="$t('Tel number dialog')">
      <b-form @submit="addTelNum">
        <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" required  v-model="newTelNum.login" :state="inputLoginState" aria-describedby="input-live-help input-live-feedback" trim/>
          <b-form-invalid-feedback id="input-live-feedback">
            {{ $t('Enter only english letters, numbers, at least 1 letter') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Incoming trunk')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="newTelNum.incoming_trunk"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Outcoming trunk')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="newTelNum.outgoing_trunk"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('PBX ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="newTelNum.pbx_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Assigned number')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="newTelNum.number"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="newTelNum.password"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Allowed CID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="newTelNum.allowed_cid"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-textarea v-model="newTelNum.comment" rows="2" />
          </b-form-group>

        <modal-ok-cancel @save="addTelNum" @cancel="hideModalTelNum"/>
      </b-form>
    </b-modal>

    <b-modal ref="accoutingPeriod" hide-footer :title="$t('Accounting period')" size="xl">
      <FormAccountinfPeriod
        v-model="telephonyService.accounting_period_id"
        @hideAccoutingPeriod="hideAccoutingPeriod"/>
    </b-modal>

    <b-modal ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="telephonyService.house_id" @hideFormHouse="hideFormHouse"></FormHouse>
    </b-modal>

    <b-modal ref="detailChargePolicies" hide-footer size="lg">
      <FormChargePolicies v-if="currentChargePolicy" @hideFormChargePolicies="hideFormChargePolicies" :currentChargePolicy="currentChargePolicy"/>
    </b-modal>

    <b-modal ref="detailCharge" hide-footer :title="$t('Periodic service statisticsperiod')">
      <FormCharged @hideFormCharged="hideFormCharged" :currentService="currentService"/>
    </b-modal>
        <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @edited="editRadiusAttr"
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>

</template>

<script>
import moment from 'moment'
import FormAccountinfPeriod from './formAccountingPeriod'
import FormHouse from '@/pages/users/usersAndGroups/detail/contacts/formHouse.vue'
import FormChargePolicies from '@/pages/tariffication/additional/chargePolicies/editModal.vue'
import FormCharged from './formCharged'
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'
export default {
  components: {
    FormAccountinfPeriod,
    FormHouse,
    FormChargePolicies,
    FormCharged,
    FormRadiusAttributs
  },
  props: {
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null,
    tariffLinkId: 0,
    accountingPeriodId: 0,
    listOfChargePolicy: null,
    listOfCoefficientScheme: null
  },
  data () {
    return {
      isEditRadiusAttr: false,
      rowRadiusAttr: null,
      radiusAttrItems: [],
      rerenderStartDate: 0,
      rerenderExpireDate: 0,
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      tabTelNum: false,
      telephonyServiceEdit: null,
      currentChargePolicy: null,
      editDocumentImage: require('@/assets/img/document_edit.png'),
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      selectedCoefficientScheme: 0,
      infinityDate: true,
      telephonyService: {
        'house_comment': '',
        'charged_in_curr_period': '',
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tplink_id': 0,
        'accounting_period_id': 0,
        'start_date': moment().unix(),
        'expire_date': moment(2000000000 * 1000).unix(),
        'policy_id': 1,
        'cost_coef': 100,
        'house_id': 0,
        'comment': '',
        'slink_id': 0,
        'numbers': [],
        'scheme_id': 0
      },
      isEditTelNum: false,
      tableTelNum: [],
      fieldsNum: [
        {key: 'login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'number', label: this.$i18n.t('Telephone'), sortable: true},
        {key: 'allowed_cid', label: this.$i18n.t('Allowed CID'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      newTelNum: {
        'login': '',
        'password': '',
        'number': '',
        'incoming_trunk': '',
        'outgoing_trunk': '',
        'pbx_id': '',
        'allowed_cid': '',
        'comment': ''
      },
      emptyTelNum: {
        'login': '',
        'password': '',
        'number': '',
        'incoming_trunk': '',
        'outgoing_trunk': '',
        'pbx_id': '',
        'allowed_cid': '',
        'comment': ''
      },
      radItemForEdit: null
    }
  },
  methods: {
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.radItemForEdit = row
      this.rowRadiusAttr = JSON.parse(JSON.stringify(row.item))
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    editRadiusAttr (radAttr) {
      if (this.radItemForEdit.item) {
        this.radiusAttrItems[this.radItemForEdit.index] = radAttr
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.radiusAttrItems))
      }
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    showFormChargePolicies () {
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        if (this.telephonyService.policy_id === el.policy_id) {
          this.currentChargePolicy = JSON.parse(JSON.stringify(el))
          this.$refs.detailChargePolicies.show()
        }
      }
    },
    hideFormChargePolicies () {
      this.$refs.detailChargePolicies.hide()
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    showFormAccountingPeriod () {
      this.$refs.accoutingPeriod.show()
    },
    hideAccoutingPeriod () {
      this.$refs.accoutingPeriod.hide()
    },
    showFormCharged () {
      this.$refs.detailCharge.show()
    },
    hideFormCharged () {
      this.$refs.detailCharge.hide()
    },
    showFormHouse () {
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.$refs.houseUser.hide()
    },
    clearHouse () {
      this.telephonyService.house_id = 0
    },
    onRowDoubleClick (item) {
      this.selectTelNum = item
      this.newTelNum = this.selectTelNum
      this.isEditTelNum = true
      this.$refs.modalTelNum.show()
    },
    rowClickHandler (row) {
      if (this.selectTelNum) {
        this.selectTelNum._rowVariant = ''
      }
      this.selectTelNum = row
      this.$set(this.selectTelNum, '_rowVariant', 'info')
    },
    showAddTelNum () {
      this.newTelNum = JSON.parse(JSON.stringify(this.emptyTelNum))
      this.isEditTelNum = false
      this.$refs.modalTelNum.show()
    },
    ClickOnEditTelNumButton (row) {
      this.selectTelNum = row.item
      this.newTelNum = this.selectTelNum
      this.isEditTelNum = true
      this.$refs.modalTelNum.show()
    },
    hideModalTelNum () {
      this.$refs.modalTelNum.hide()
    },
    addTelNum () {
      if (!this.validation()) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('"Login" is incorrect'), 'Error')
        this.hideModalTelNum()
        return
      }
      if (!this.isEditTelNum) {
        this.tableTelNum.push(this.newTelNum)
      }
      this.hideModalTelNum()
    },
    deleteTelNum (row) {
      this.selectTelNum = row.item
      this.tableTelNum = this.tableTelNum.filter((value) => {
        return value !== this.selectTelNum
      })
    },
    validation () {
      if (this.newTelNum.login.length === 0) {
        return false
      }
      let strArray = this.newTelNum.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.newTelNum.login.length
    },
    addCoefSchemeToSlink (newSlinkId) {
      if ((!this.isEdit && this.telephonyService.scheme_id > 0) ||
     (this.telephonyServiceEdit !== null &&
     this.telephonyServiceEdit.coefficientschedulelink === undefined &&
     this.telephonyService.scheme_id > 0)) {
        let coefSchedule = {items: []}
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === this.telephonyService.scheme_id) {
            coefSchedule.items = el.items
            coefSchedule.repeat_period = el.repeat_period
          }
        }
        let responseCoefScheduleId = this.$store.dispatch('Users/CREATE_COEFFICIENT_SCHEDLE', coefSchedule)
        responseCoefScheduleId.then(responseCoefScheduleId => {
          let newCoefScheduleId = responseCoefScheduleId.data.coefficient_schedule_id
          let schedule = {
            scheme_id: this.telephonyService.scheme_id,
            slink_id: Number(newSlinkId),
            schedule_id: Number(newCoefScheduleId),
            change_policy: 0
          }
          this.$store.dispatch('Users/CREATE_UERS_SERVICELINKS_COEFFICIENT_SCHEDLE', schedule)
        })
      }
    },
    async saveTelephonyService () {
      if (this.telephonyService.accounting_period_id === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
      } else if (this.tableTelNum.length === 0) {
        this.tabTelNum = true
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Telephony numbers table is empty'), 'Error')
      } else {
        let tmpTelephonyService = JSON.parse(JSON.stringify(this.telephonyService))
        tmpTelephonyService.cost_coef = tmpTelephonyService.cost_coef / 100
        tmpTelephonyService.expire_date = this.infinityDate ? 2000000000 : tmpTelephonyService.expire_date
        tmpTelephonyService.numbers = this.tableTelNum
        tmpTelephonyService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
        if (this.isEdit) {
          tmpTelephonyService.slink_id = this.currentService.service_link_id
        } else {
          tmpTelephonyService.account_id = this.selectedAccount
          tmpTelephonyService.service_id = this.currentService.service_id
          tmpTelephonyService.user_id = this.currentUser.user_id
        }
        let response = this.isEdit
          ? this.$store.dispatch('Users/UPDATE_TELEPHONY_SERVICE_LINK', tmpTelephonyService)
          : this.$store.dispatch('Users/CREATE_TELEPHONY_SERVICE_LINK', tmpTelephonyService)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            let radiusAttr = {
              'set_object_id': 0,
              'set_type': 10000,
              'attrs': []
            }
            radiusAttr.attrs = this.radiusAttrItems
            if (this.isEdit) {
              radiusAttr.set_object_id = this.currentService.service_link_id
            } else {
              radiusAttr.set_object_id = response.data.service_link_id
            }
            this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', radiusAttr)

            let newSlinkId = response.data.service_link_id ? response.data.service_link_id : this.currentService.service_link_id
            this.addCoefSchemeToSlink(newSlinkId)
            this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
            this.hideSelectService()
            this.$root.$emit('makeToasts')
          }
        })
      }
    },
    coeffSchemeChanged (schemeId) {
      if (schemeId === 0) {
        this.telephonyService.cost_coef = 100
      } else {
        let newCostCoef = 100
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === schemeId) {
            for (let elIt of el.items) {
              if (elIt.delay === 0) {
                newCostCoef = elIt.coeff * 100
                break
              }
            }
            break
          }
        }
        this.telephonyService.cost_coef = Math.round(newCostCoef)
      }
    }
  },
  mounted () {
    this.telephonyService.scheme_id = this.currentService.scheme_id
    this.coeffSchemeChanged(this.currentService.scheme_id)

    if (this.isEdit) {
      this.$store.dispatch('Tariffing/GET_RADIUS_ATTR_SLINK', {slink_id: this.currentService.service_link_id})
      this.$store.dispatch('Users/GET_TELEPHONY_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.telephonyServiceEdit = this.$store.getters['Users/TELEPHONY_SERVICE_LINK']
        this.telephonyService.start_date = this.telephonyServiceEdit.periodicservicelink.start_date
        this.telephonyService.expire_date = this.telephonyServiceEdit.periodicservicelink.expire_date
        this.rerenderStartDate += 1
        this.rerenderExpireDate += 1
        this.infinityDate = this.telephonyServiceEdit.periodicservicelink.expire_date === 2000000000
        this.telephonyService.cost_coef = this.telephonyServiceEdit.periodicservicelink.cost_coef * 100
        this.telephonyService.comment = this.telephonyServiceEdit.periodicservicelink.comment
        this.telephonyService.house_comment = this.telephonyServiceEdit.periodicservicelink.house_comment
        this.telephonyService.accounting_period_id = this.telephonyServiceEdit.periodicservicelink.accounting_period_id
        this.telephonyService.house_id = this.telephonyServiceEdit.periodicservicelink.house_id
        this.telephonyService.policy_id = this.telephonyServiceEdit.periodicservicelink.policy_id
        this.tableTelNum = this.telephonyServiceEdit.telephonyServiceLink.numbers
        this.telephonyService.charged_in_curr_period = Number.parseFloat(this.telephonyServiceEdit.periodicservicelink.charged_in_curr_period).toFixed(3)
        if (this.telephonyServiceEdit.coefficientschedulelink) {
          this.telephonyService.scheme_id = this.telephonyServiceEdit.coefficientschedulelink.scheme_id
        }
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_SLINK']))
        for (let el of this.radiusAttrItems) {
          el.value = el.attr_value
          if (el.tag && (el.vendor === 0)) {
            el.value = ':' + el.tag + ':' + el.attr_value
          }
          switch (el.attr_type) {
            case 1:
              el.attrType = this.$i18n.t('Number')
              break
            case 2:
              el.attrType = this.$i18n.t('String')
              break
            case 3:
              el.attrType = 'IP'
              break
            case 4:
              el.attrType = this.$i18n.t('Binary')
              break
          }
        }
      })
    } else {
      this.telephonyService.policy_id = this.currentService.policy_id
      this.telephonyService.accounting_period_id = this.accountingPeriodId ? this.accountingPeriodId : 0
    }
    if (this.currentService.addByDefault) {
      this.saveTelephonyService()
    }
  },
  computed: {
    radAttrsSlink () {
      return this.$store.getters['Tariffing/RADIUS_ATTR_SLINK']
    },
    inputLoginState () {
      return this.validation()
    },
    selectAccountingPeriod () {
      let selectAccountingPeriod = ''
      if (this.telephonyService.accounting_period_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))) {
          if (el.id === this.telephonyService.accounting_period_id) {
            el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
            el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
            selectAccountingPeriod = el.begin + ' / ' + el.end + ' (' + el.id + ')'
          }
        }
      }
      return selectAccountingPeriod
    },
    userHouse () {
      let userHouse = ''
      if (this.telephonyService.house_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/BUILDINGS']))) {
          if (el.house_id === this.telephonyService.house_id) {
            if (el.post_code.length > 0) {
              userHouse += el.post_code + ', '
            }
            if (el.country.length > 0) {
              userHouse += el.country + ', '
            }
            if (el.region.length > 0) {
              userHouse += el.region + ', '
            }
            if (el.city.length > 0) {
              userHouse += el.city + ', '
            }
            if (el.street.length > 0) {
              userHouse += el.street + ', '
            }
            if (el.number.length > 0) {
              userHouse += el.number + ', '
            }
            if (el.building.length > 0) {
              userHouse += el.building + ', '
            }
            userHouse += '(' + el.house_id + ')'
            break
          }
        }
      }
      return userHouse
    }
  },
  watch: {
    // telephonyService: {
    //   deep: true,
    //   handler: function (newV, oldV) {
    //     this.telephonyService.cost = Math.round(Number(this.telephonyService.cost))
    //   }
    // },
    radAttrsSlink: function (items) {
      this.radiusAttrItems = items
      for (let el of this.radiusAttrItems) {
        el.value = el.attr_value
        if (el.tag && (el.vendor === 0)) {
          el.value = ':' + el.tag + ':' + el.attr_value
        }
        switch (el.attr_type) {
          case 1:
            el.attrType = this.$i18n.t('Number')
            break
          case 2:
            el.attrType = this.$i18n.t('String')
            break
          case 3:
            el.attrType = 'IP'
            break
          case 4:
            el.attrType = this.$i18n.t('Binary')
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formTelephony.vue